import { ReactElement } from "react"

import { ApplicationTag } from "../../../constants/enums"
import AppChip from "../../dataDisplay/chips/appChip"

const applicationTagMapper: Record<ApplicationTag, string> = {
    G98: "G98",
    G99: "G99",
    "SGI-1": "G99 Fast Track SGI-1",
    "SGI-2": "G99 Fast Track SGI-2",
    "SGI-3": "G99 Fast Track SGI-3",
    Demand: "Demand",
}

interface ITagChipProps {
    tag: ApplicationTag
}

const TagChip = ({ tag }: ITagChipProps): ReactElement | null => {
    const userFriendlyText = applicationTagMapper[tag]

    if (!userFriendlyText) {
        return null
    }

    return (
        <AppChip
            sx={{ mr: 1 }}
            label={userFriendlyText}
            variant="outlined"
            color="primary"
        />
    )
}

export default TagChip
